import _ from 'lodash';
import { EnvironmentDetail } from '@utils/EnvironmentDetailUtils';

const CandyCaneLogConstants = {
    JSON_STRINGIFY_SPACE: 0,
    NO_ERROR_MESSAGE_OR_STACK_TRACE_STRING: '<empty>',
    CANNOT_CONVERT_OBJECT_TO_STRING_MESSAGE: '<cannot convert object to string>',
    CANNOT_STRINGIFY_OBJECT_MESSAGE: '[object Object]',
    DEFAULT_LOG_LEVEL: 'warn',
    LOG_LEVELS: Object.freeze(['debug', 'log', 'info', 'warn', 'error']),
};

const originalLog = {};

export function candyCaneLogDecorator() {
    if (!EnvironmentDetail.isAndroid()) {
        return;
    }

    CandyCaneLogConstants.LOG_LEVELS.forEach((level) => {
        originalLog[level] = console[level];
        console[level] = logFunctionFactory(level);
    });
}

function logFunctionFactory(level: string) {
    return function () {
        log({
            level,
            args: arguments,
        });
    };
}

function log(logArgsWithLevel: { level: string; args: IArguments }) {
    const logMessage = parseArgs(logArgsWithLevel.args);
    const fn = originalLog[logArgsWithLevel.level] || originalLog[CandyCaneLogConstants.DEFAULT_LOG_LEVEL];

    fn.apply(console, [logMessage]);
}

function parseArgs(args: IArguments) {
    const argsAsStrings = _.map(args, function (arg) {
        if (_.isNull(arg) || _.isUndefined(arg)) {
            return safeToString(arg);
        }

        if (arg instanceof Error) {
            return formatError(arg);
        }

        if (_.isElement(arg) || _.isFunction(arg)) {
            return safeToString(arg);
        }

        if (_.isString(arg)) {
            return '"' + arg + '"';
        }

        if (_.isObject(arg)) {
            return toJson(arg);
        }

        return safeToString(arg);
    });

    return argsAsStrings.join(' ');
}

function safeToString(arg: any) {
    try {
        return '' + arg;
    } catch (e) {
        return CandyCaneLogConstants.CANNOT_CONVERT_OBJECT_TO_STRING_MESSAGE;
    }
}

function formatError(error: Error) {
    let errorString = '';

    if (error.message) {
        errorString += error.message;
    }

    if (error.stack) {
        errorString += '\n' + safeToString(error.stack);
    }

    if (errorString === '') {
        errorString += CandyCaneLogConstants.NO_ERROR_MESSAGE_OR_STACK_TRACE_STRING;
    }

    return 'Error: ' + errorString;
}

function toJson(arg: any) {
    try {
        return JSON.stringify(arg, null, CandyCaneLogConstants.JSON_STRINGIFY_SPACE);
    } catch (e) {
        return CandyCaneLogConstants.CANNOT_STRINGIFY_OBJECT_MESSAGE;
    }
}
